
// export const getAccount = state =>
//   (state.user ? Object.assign({}, state.user) : null);
export const getAccount = state => Object.assign({}, state.user);
export const getLoading = state => state.loading;




// WEBPACK FOOTER //
// ./src/redux/account/selectors.js